import { Component } from '@angular/core';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { TopbarService } from 'src/app/core/topbar/topbar.service';
import { FormValidatorService } from 'src/app/core/services/form-validator.service';
import { LoginService } from '../../login/login.service';
import { firstValueFrom } from 'rxjs';
import { CaseLogType } from '../../cases/_types/case-log-type';
import { CaseLogTypesService } from '../../cases/_services/cases-log-types.service';
import { Dataset } from '../../reports/_types/dataset';
import { DatasetsService } from '../../reports/_services/datasets.service';
import { DatasetsFieldsService } from '../../reports/_services/datasets-fields.service';
import { DatasetField } from '../../reports/_types/dataset-field';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { Filter, FilterOperation } from 'src/app/core/jsonapi/filter';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';

@Component({
    selector: 'app-datasets-detail',
    templateUrl: './datasets-detail.component.html',
    styleUrls: ['./datasets-detail.component.scss'],
    standalone: false
})
export class DatasetsDetailComponent {
  public datasetFormGroup!: RxFormGroup;

  public dataset: Dataset = new Dataset();
  public datasetFields: DatasetField[] = [];

  public editorVisible: boolean = false;

  public allowWrite: boolean = false;
  public allowDelete: boolean = false;

  public editorOptionsSql = {theme: 'vs-dark', language: 'sql', height: '100%'};
  public editorOptionsItems = {theme: 'vs-dark', language: 'javascript', height: '100%'};

  public dataTypes: any[] = [
    { label: 'Texto', value: 'string' },
    { label: 'Fecha', value: 'date' },
    { label: 'Fecha y hora', value: 'datetime' },
    { label: 'Numero', value: 'number' },
    { label: 'Si/No', value: 'bool' }
  ];
  public optionsModes: any[] = [
    { label: 'No', value: '' },
    { label: 'Sql', value: 'sql' },
    { label: 'Lista manual', value: 'items' }
  ];


  constructor(
    private datasetsService: DatasetsService,
    private datasetFieldsService: DatasetsFieldsService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private route: ActivatedRoute,
    private router: Router,
    private topbarService: TopbarService,
    private formBuilder: RxFormBuilder,
    private formValidationService: FormValidatorService
  ) {

    this.datasetFormGroup = this.formBuilder.formGroup<Dataset>(this.dataset) as RxFormGroup;
  }

  async ngOnInit() {
    this.topbarService.setTitle("Detalle");
    this.topbarService.addBreadcrumb("Conjuntos de datos", "/datasets");
    let id = this.route.snapshot.params['id'];
    if (id != null && id != '0') {
      await this.loadDatasets(id);
      await this.loadDatasetFields(id);
    }
    this.allowWrite = true; // this.loginService.hasPermission("DATASETS.WRITE");
    this.allowDelete = true; // this.loginService.hasPermission("DATASETS.DELETE");
    setTimeout(() => {
      this.editorVisible = true;
    }, 1000);
  }

  async loadDatasets(id: string) {
    this.dataset = await firstValueFrom(this.datasetsService.get(id));
    this.datasetFormGroup.patchValue(this.dataset);
  }

  async loadDatasetFields(id: string) {
    let filters = {
      datasetId: new Filter(FilterOperation.equals, 'datasetId', '', id)
    };
    let params:IParamsCollection = {
      page: {
        size: 1000,
        number: 0
      },
      filter: FilterBuilder.fromObject(filters).build()
    };
    let response = await firstValueFrom(this.datasetFieldsService.all(params));
    this.datasetFields = response.data;
  }

  async save() {
    let valid = this.formValidationService.validateForm(this.datasetFormGroup);
    if (valid) {
      this.dataset = Object.assign(this.dataset, this.datasetFormGroup.value);
      this.dataset = await firstValueFrom(this.datasetsService.save(this.dataset));
      this.messageService.add({ closable: true, severity: 'success', summary: "Guardado correctamente." });
      this.loadDatasetFields(this.dataset.id!);
    } else {
      this.messageService.add({ closable: true, severity: 'error', summary: "Error", detail: "Existen errores, por favor revise el formulario de datos." });
    }
  }

  async saveField(datasetField:DatasetField){
    let datasetFieldSaved = await firstValueFrom(this.datasetFieldsService.save(datasetField));
    this.messageService.add({ closable: true, severity: 'success', summary: "Guardado correctamente." });
  }

  async delete() {
    this.confirmationService.confirm({
      message: "¿Está seguro que desea eliminar el registro?",
      header: "Eliminar registro",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.datasetsService.delete(this.dataset.id).subscribe({
          next: (data: any) => {
            this.cancel();
            this.messageService.add({ closable: true, severity: 'success', detail: "Registro eliminado correctamente." });
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      },
      reject: (error: any) => {
        this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
      }
    });
  }

  cancel() {
    this.router.navigate(['datasets']);
  }
}
